import { LocaleContext } from '../../../providers/locale-provider'
import { Answer, Question } from '../../../types/questions'
import { ChoiceList, ChoiceListTypes, FormCheckbox } from '../../../../MyStichtingOpenComponents/src'
import { ChangeEvent, useContext } from 'react'
import { Control, FieldValues, Controller } from 'react-hook-form'

type CheckboxQuestionProps = {
    question: Question
    name: string
    control: Control<FieldValues, any>
    inline: boolean
}

const CheckboxQuestion = ({ question, name, control, inline }: CheckboxQuestionProps): JSX.Element => {
    const localeContext = useContext(LocaleContext)

    return (
        <>
            {localeContext.getLocaleText(question.questionContent.text)}
            <ChoiceList
                type={inline ? ChoiceListTypes.INLINE : ChoiceListTypes.DEFAULT}
                className={`${inline ? 'items-center gap-2' : 'w-full'}`}
            >
                <Controller
                    control={control}
                    name={name}
                    shouldUnregister
                    defaultValue={[]}
                    render={({ field: { onChange, value } }) => (
                        <>
                            {question.questionContent.answers.map((answer: Answer) => (
                                <FormCheckbox
                                    key={answer.id}
                                    name={name}
                                    checked={value.some((existingValue: string) => existingValue === answer.id)}
                                    value={answer.id}
                                    label={localeContext.getLocaleText(answer.text)}
                                    onChange={(internalValue: ChangeEvent<HTMLInputElement>, checked: boolean) => {
                                        if (checked) {
                                            onChange([...value, internalValue.target.value])
                                        } else {
                                            onChange(
                                                value.filter(
                                                    (fieldValue: any) => fieldValue !== internalValue.target.value,
                                                ),
                                            )
                                        }
                                    }}
                                    boxed={inline}
                                />
                            ))}
                        </>
                    )}
                />
            </ChoiceList>
        </>
    )
}

export default CheckboxQuestion
